/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/control-has-associated-label */
import React from 'react';

import { Box } from '@material-ui/core';

import Image from '../../../Image';
import LetsEncrypt from '../../components/LetsEncrypt';

const FooterSecurity = () => (
  <Box display="flex" flexWrap="wrap" maxWidth="300px">
    <Box display="flex" justifyContent="center" alignItems="center" width="150px" padding="8px">
      <Image
        defaultSize="https://cdn.smartbr.com/resources/imgs/rdpe/ambiente-seguro.png"
        lazyLoad={false}
        usePicture={false}
      />
    </Box>
    <Box display="flex" justifyContent="center" alignItems="center" width="150px" padding="8px">
      <LetsEncrypt />
    </Box>
    {typeof window !== 'undefined' && !window.location.hostname.includes('arktus') && (
      <a
        style={{ cursor: 'pointer' }}
        href={`https://transparencyreport.google.com/safe-browsing/search?url=https:%2F%2F${window.location.hostname}&hl=pt_BR`}
      >
        <Box display="flex" justifyContent="center" alignItems="center" width="150px" padding="8px">
          <Image
            defaultSize="https://cdn.smartbr.com/certificate-google.png"
            lazyLoad={false}
            usePicture={false}
            title="Certificado Google"
          />
        </Box>
      </a>
    )}
    <Box>
      <div id="ra-verified-seal" />
    </Box>
    <Box display="flex" justifyContent="center" alignItems="center" width="150px" padding="8px">
      <div id="reputation-ra" hidden />
    </Box>
  </Box>
);

export default FooterSecurity;
